<template>
    <tr v-on:click.stop="showTrip" v-bind:class="{'text-cancelled' : isCancelled, 'booking-enquiry' : isEnquiry || isBlockOut}">
        <td><span class="d-inline d-sm-none">{{friendlyShort(booking.arrival)}}</span><span class="d-none d-sm-inline">{{friendlyDate(booking.arrival)}}</span></td>
        <td><span class="d-inline d-sm-none">{{friendlyShort(booking.departure)}}</span><span class="d-none d-sm-inline">{{friendlyDate(booking.departure)}}</span></td>
        <td class="list-bookings__guest-name">
            <guest-name v-bind:guest="booking.guest"></guest-name>
        </td>
        <td class="list-bookings__guest-name">
            <guest-last-name v-bind:guest="booking.bookedBy"></guest-last-name>
        </td>
        <td class="list-bookings__guest-name">
            <guest-last-name v-bind:guest="booking.billedTo"></guest-last-name>
        </td>
        <td class="d-none d-sm-table-cell">{{friendlyDateAndTime(booking.dateBooked)}}</td>
        <td class="tabular__actions">
            <div class="d-none d-sm-inline">
                <template v-if="isMigrating">
                    <div class="tooltip-container d-inline">
                        <div v-on:click.stop="confirmMigrateAction"
                             v-on:mouseenter="showStateTooltip = true"
                             v-on:mouseleave="showStateTooltip = false"
                             class="booking__state booking__state--migrating">
                            <i class="fas fa-play"></i>
                        </div>
                        <tooltip v-bind:visible="showStateTooltip"
                                 v-bind:position="'bottom-left'"
                                 v-bind:text="'Migrating. Click here to activate and create tasks from automations.'"></tooltip>
                    </div>
                </template>
                <template v-else-if="isRequestingAmendment">
                    <div class="tooltip-container d-inline">
                        <div v-on:click.stop="confirmAmendAction"
                             v-on:mouseenter="showStateTooltip = true"
                             v-on:mouseleave="showStateTooltip = false"
                             class="booking__state booking__state--requesting-amendment">
                            <i class="fas fa-play"></i>
                        </div>
                        <tooltip v-bind:visible="showStateTooltip"
                                 v-bind:position="'bottom-left'"
                                 v-bind:text="'Guest Requested Amendment. Click here to accept or reject the changes.'"></tooltip>
                    </div>
                </template>
                <template v-else-if="isManuallyUpdating">
                    <div class="tooltip-container d-inline">
                        <div v-on:click.stop="confirmManuallyUpdateAction"
                             v-on:mouseenter="showStateTooltip = true"
                             v-on:mouseleave="showStateTooltip = false"
                             class="booking__state booking__state--manually-updating">
                            <i class="fas fa-hand-paper"></i>
                        </div>
                        <tooltip v-bind:visible="showStateTooltip"
                                 v-bind:position="'bottom-left'"
                                 v-bind:text="'Manually Updating. Click here to manually update the booking details.'"></tooltip>
                    </div>
                </template>
                <template v-else>
                    <div class="tooltip-container d-inline">
                        <!-- NOTE: Booking can return true to isNoContactDetails(), so it overrides state colouring  -->
                        <div class="booking__state"
                             v-on:mouseenter="showStateTooltip = true"
                             v-on:mouseleave="showStateTooltip = false"
                             v-bind:class="{'booking__state--enquiry' : isEnquiry,
                                            'booking__state--active' : isActive,
                                            'booking__state--cancelled' : isCancelled,
                                            'booking__state--block-out' : isBlockOut,
                                            'booking__state--override-no-contact-details' : isNoContactDetails}">
                        </div>
                        <tooltip v-bind:visible="showStateTooltip"
                                 v-bind:position="'bottom-left'"
                                 v-bind:text="tooltipTextForStateForBooking"></tooltip>
                    </div>
                </template>
                <template v-if="!booking.externalBookingId">
                    <div class="tooltip-container d-inline">
                        <button class="btn-small">
                            <i v-on:click.stop="editBooking" v-on:mouseenter="showEditTooltip = true" v-on:mouseleave="showEditTooltip = false" class="fas fa-edit"></i>
                        </button>
                        <tooltip v-bind:visible="showEditTooltip" v-bind:position="'bottom'" text="Edit"></tooltip>
                    </div>

                    <div class="tooltip-container d-inline">
                        <button class="btn-small">
                            <i v-on:click.stop="confirmDeleteAction" v-on:mouseenter="showDeleteTooltip = true" v-on:mouseleave="showDeleteTooltip = false" class="fas fa-trash-alt"></i>
                        </button>
                        <tooltip v-bind:visible="showDeleteTooltip" v-bind:position="'bottom'" text="Cancel"></tooltip>
                    </div>
                </template>
            </div>
            <div v-on:click.stop="showMobileStateActionsPopup" class="d-inline d-sm-none">
                <!-- NOTE: Booking can return true to isNoContactDetails(), so it overrides state colouring  -->
                <div class="booking__state booking__state-mobile"
                     v-on:mouseenter="showStateTooltip = true"
                     v-on:mouseleave="showStateTooltip = false"
                     v-bind:class="{'booking__state--enquiry' : isEnquiry,
                                    'booking__state booking__state--migrating' : isMigrating,
                                    'booking__state--requesting-amendment' : isRequestingAmendment,
                                    'booking__state--active' : isActive,
                                    'booking__state--cancelled' : isCancelled,
                                    'booking__state--block-out' : isBlockOut,
                                    'booking__state--override-no-contact-details' : isNoContactDetails}">
                    <i v-if="hasActions" class="fas fa-ellipsis-h"></i>
                    <div v-click-outside="hideAllMobileStateActionsPopups" v-if="showStateActions" v-on:click="hideAllMobileStateActionsPopups" class="booking__state-mobile__actions">
                        <ul>
                            <li v-if="isMigrating" v-on:click.stop="confirmMigrateAction">
                                <span class="booking__state-mobile__icon"><i class="fas fa-play"></i></span>
                                Migrate and create tasks
                            </li>
                            <li v-if="isRequestingAmendment" v-on:click.stop="confirmAmendAction">
                                <span class="booking__state-mobile__icon"><i class="fas fa-play"></i></span>
                                Reject amendment request
                            </li>
                            <li v-if="isManuallyUpdating" v-on:click.stop="confirmManuallyUpdateAction">
                                <span class="booking__state-mobile__icon"><i class="fas fa-hand-paper"></i></span>
                                Manually update changes
                            </li>
                            <li v-if="!booking.externalBookingId" v-on:click.stop="editBooking">
                                <span class="booking__state-mobile__icon"><i class="fas fa-edit"></i></span>
                                Edit Booking
                            </li>
                            <li v-if="!booking.externalBookingId" v-on:click.stop="confirmDeleteAction">
                                <span class="booking__state-mobile__icon"><i class="fas fa-trash-alt"></i></span>
                                Delete Booking
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
    import Tooltip from '../../components/Tooltip'
    import GuestName from '../../components/GuestName'
    import GuestLastName from '../../components/GuestLastName'

    import {bookingsMixin} from "../../mixins/BookingsMixin"
    import {datesMixin} from "../../mixins/DatesMixin"

    export default {
        name: "BookingSummary.vue",
        components: { Tooltip, GuestName, GuestLastName },
        mixins: [bookingsMixin, datesMixin],
        props: {
            booking: Object
        },
        data: function () {
            return {
                showEditTooltip: false,
                showDeleteTooltip: false,
                showStateTooltip: false,
                showStateActions: false,
            }
        },
        computed: {
            hasActions: function() {
                if (this.isMigrating || this.isRequestingAmendment || !this.booking.externalBookingId) {
                    return true;
                }
                return false;
            }
        },
        methods: {
            showTrip: function() {
                this.$root.$emit('show-trip', this.booking);
            },
            editBooking: function () {
                this.$root.$emit("hide-all-booking-state-action-popups");
                this.$root.$emit('edit-booking', this.booking);
            },
            confirmDeleteAction: function() {
                this.$root.$emit("hide-all-booking-state-action-popups");
                this.$root.$emit('confirm-delete-booking', this.booking);
            },
            confirmMigrateAction: function() {
                this.$root.$emit("hide-all-booking-state-action-popups");
                this.$root.$emit('confirm-migrate-booking', this.booking);
            },
            confirmAmendAction: function() {
                this.$root.$emit("hide-all-booking-state-action-popups");
                this.$root.$emit('confirm-amend-booking', this.booking);
            },
            confirmManuallyUpdateAction: function() {
                this.$root.$emit("hide-all-booking-state-action-popups");
                this.$root.$emit('confirm-manually-update-booking', this.booking);
            },
            showMobileStateActionsPopup: function() {
                console.log("SHOWING");
                this.hideAllMobileStateActionsPopups();
                if (this.isMigrating || this.isRequestingAmendment || !this.booking.externalBookingId) {
                    this.showStateActions = true;
                }
            },
            hideMobileStateActionsPopup: function() {
                console.log("HIDING");
                this.showStateActions = false;
            },
            hideAllMobileStateActionsPopups: function () {
                this.$root.$emit("hide-all-booking-state-action-popups");
            }
        },
        mounted() {
            this.$root.$on('hide-all-booking-state-action-popups', this.hideMobileStateActionsPopup);
        },
        beforeDestroy () {
            this.$root.$off('hide-all-booking-state-action-popups', this.hideMobileStateActionsPopup);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/pages/list-forms";
    @import "../../styles/pages/list-bookings";
</style>